import type { SVGProps } from 'react';
const SvgDeleteSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={14} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M12.278 2.1c.191 0 .375.074.51.205A.7.7 0 0 1 13 2.8a.7.7 0 0 1-.211.495.73.73 0 0 1-.511.205h-.722l-.003.05-.673 9.15c-.026.353-.19.683-.457.925A1.47 1.47 0 0 1 9.44 14H3.56a1.47 1.47 0 0 1-.985-.376 1.38 1.38 0 0 1-.456-.925L1.446 3.55l-.002-.05H.722a.73.73 0 0 1-.51-.205A.7.7 0 0 1 0 2.8a.7.7 0 0 1 .212-.495.73.73 0 0 1 .51-.205zM7.944 0c.192 0 .376.074.511.205A.7.7 0 0 1 8.667.7a.7.7 0 0 1-.212.495.73.73 0 0 1-.51.205h-2.89a.73.73 0 0 1-.51-.205A.7.7 0 0 1 4.333.7a.7.7 0 0 1 .212-.495.73.73 0 0 1 .51-.205z"
    />
  </svg>
);
export default SvgDeleteSmall;
